
<div class="bmc-sync-data__wrapper">
  <div  *ngIf="isLoading"  class="bmc-sync-data__loader">
    <bounce>
      {{'SYNC_DATA.EXPORTING_DATA' | translate}}
    </bounce>
  </div>
  <div class="bmc-syncdata-export-step3" [ngClass]="messageToUser ? 'bmc-syncdata-export-step3--error' : ''">
    <h2 class="bmc-syncdata-export-step3__title">{{'SYNC_DATA.SELECT_ENTITY_KEYS' | translate}}</h2>
    <label class="bmc-syncdata-export-step3__subtitle">{{'SYNC_DATA.CHOOSE_ENTITIES_KEYS_DO_YOU_NEED_TO_EXPORT' | translate}}</label>
    <div class="bmc-syncdata-export-step3__table">
      <div class="bmc-syncdata-export-step3__container bmc-syncdata-export-step3__container--left" >
        <div class="bmc-syncdata-export-step3__container__title bmc-syncdata-export-step3__container__title--left">
          <label class="bmc-syncdata-export-step3__container__title__text">&nbsp;&nbsp;{{ 'SYNC_DATA.SELECT_ENTITY_VALUES' | translate}}</label>
        </div>
        <div>
          <ul class="bmc-syncdata-export-step3__list">
            <li *ngFor="let item of selectedTables" class="bmc-syncdata-export-step3__list__item"
              [ngClass]="item.SelectedUI ? 'bmc-syncdata-export-step3__list__item--selected' : ''"
              (click)="onTableSelected(item);">
              <div>
                <label class="bmc-syncdata-export-step3__list__item--text">{{item.DisplayName}}</label>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class ="bmc-syncdata-export-step3__container bmc-syncdata-export-step3__container--right">
        <div class="bmc-syncdata-export-step3__container__title bmc-syncdata-export-step3__container__title--right">
            <label class="bmc-syncdata-export-step3__container__title__text">&nbsp;&nbsp;{{ 'SYNC_DATA.ENTITY_KEYS' | translate}}</label>
        </div>
        <div class="listEntityKeys">
          <div>
            <ul class="bmc-syncdata-export-step3__list">
              <li *ngFor="let entityKey of filteredEntities; let i = index" class="bmc-syncdata-export-step3__checkbox-item">


          <svg [style.visibility]="entityKey.Isbusinesskey ? 'inline' : 'hidden'" class="bz-icon-svg bz-icon-svg--16">
            <use href="#icon-key"></use>
          </svg>
                <div class="bz-checkbox">
                    <bzg-checkbox [(ngModel)]="entityKey.Selected" (change)="onSelectEntity(entityKey)" [checked] = "entityKey.Selected">
                      &nbsp;&nbsp;{{entityKey.DisplayName}}
                    </bzg-checkbox>
                  </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="messageToUser" class="bmc-sync-data__error">
      <svg class="bz-icon-svg bz-icon-svg--16 bmc-sync-data__error__icon">
        <use href="#icon-warning"></use>
      </svg>
      <label class="bmc-sync-data__error__label">{{messageToUser | translate}} {{messageEntitiesRequired}}</label>
    </div>
  </div>
</div>
